import React from 'react';
import { Dropdown } from 'react-bootstrap';
import cn from 'classnames';
import styles from '../Dropdown.module.css';
import DropdownItem from '../DropdownItem/DropdownItem';
import Form from 'react-bootstrap/Form';

interface DropdownItemProp {
  eventKey: string;
  label: string;
}

interface DropdownMenuProps {
  items: DropdownItemProp[];
  onSelect: (eventKey: string) => void;
  searchable?: boolean;
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  items,
  onSelect,
  searchable,
  searchQuery,
  setSearchQuery,
}) => (
  <Dropdown.Menu className={cn(styles.customstyle)}>
    {searchable && setSearchQuery && (
      <div className={styles.searchWrapper}>
        <Form.Control
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
          className={styles.searchInput}
        />
      </div>
    )}
    {items.map((item, index) => (
      <DropdownItem
        key={index}
        eventKey={item.eventKey}
        label={item.label}
        onSelect={onSelect}
      />
    ))}
  </Dropdown.Menu>
);

export default DropdownMenu;
